export const PRE_MODERATION = '/pre-moderation/'
export const PRE_MODERATION_ALL = `${PRE_MODERATION}`
export const PRE_MODERATION_ASSIGNED = `${PRE_MODERATION}assigned`
export const PRE_MODERATION_ITEM = `${PRE_MODERATION}:id`
